import clsx from "clsx";

/**
 * Shared email-list row (EM-6) — the focus-mode look, used by BOTH the per-deal
 * focus Email tab and the all-inbox cockpit Email panel so they render
 * identically. Takes only the fields both inbox shapes (InboxEmail / InboxLite)
 * provide.
 */
export interface EmailRowItem {
  id: string;
  direction: "incoming" | "outgoing";
  from: { name: string; email: string };
  to: Array<{ name: string; email: string }>;
  subject: string;
  snippet: string;
  receivedDateTime: string;
  isRead: boolean;
  hasAttachments: boolean;
}

const DATE_FMT = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: "America/Los_Angeles",
});

export function EmailListRow({
  email,
  onClick,
}: {
  email: EmailRowItem;
  onClick: () => void;
}) {
  const dirCls = email.direction === "outgoing" ? "email-dir-out" : "email-dir-in";
  return (
    <div className={clsx("email-row", !email.isRead && "unread")} onClick={onClick}>
      <span className={clsx("email-dir-tag", dirCls)}>
        {email.direction === "outgoing" ? "SENT" : "RECV"}
      </span>
      <div className="email-row-main">
        <div className="email-row-top">
          <span className="email-row-from">
            {email.direction === "outgoing"
              ? "To: " + (email.to[0]?.name || email.to[0]?.email || "—")
              : email.from.name || email.from.email || "Unknown"}
          </span>
          <span className="email-row-date">
            {email.receivedDateTime
              ? DATE_FMT.format(new Date(email.receivedDateTime))
              : ""}
          </span>
        </div>
        <div className="email-row-subject">
          {!email.isRead && <span className="email-unread-dot">●</span>}
          {email.subject}
          {email.hasAttachments && (
            <span className="email-row-attach" title="Has attachments">
              {" "}
              📎
            </span>
          )}
        </div>
        <div className="email-row-snippet">{email.snippet}</div>
      </div>
      <span className="email-row-chevron">▸</span>
    </div>
  );
}
